import React from 'react'
import { useSelector } from 'react-redux'
import Image from 'next/image'

const SliderViewMobile = ({ selectedOption1, handleSelectedOptionChange, selectedParameters }) => {
  const { textToImagePrompts } = useSelector((state) => state.prompt)

  const handleImageError = (event) => {
    event.target.src = '/assets/agents-dummy/placeholder.svg'
  }

  return (
    <div className="flex flex-row overflow-x-auto gap-1">
      {textToImagePrompts &&
        textToImagePrompts[selectedOption1]?.map((item, i) => {
          return (
            <div
              className="overflow-hidden flex-none !w-12 md:!w-[100px]"
              onClick={() => handleSelectedOptionChange(selectedOption1, item)}
              key={i}
            >
              <div className="relative !h-12 !w-12 md:!h-[100px] md:!w-[100px]">
                <Image
                  src={item.prompt_imageURL || '/assets/agents-dummy/placeholder.svg'}
                  alt={item?.title || 'Prompt Image'}
                  fill
                  className={`!rounded-full object-cover ${
                    selectedParameters && selectedParameters?.[selectedOption1]?.title == item?.title
                      ? 'border-2 border-solid border-blue-500'
                      : ''
                  }`}
                  onError={handleImageError}
                  sizes="(max-width: 768px) 48px, 100px"
                />
              </div>
              <p className="break-words mt-2 text-[10px] leading-none text-center font-medium capitalize">
                {item?.title}
              </p>
            </div>
          )
        })}
    </div>
  )
}

export default SliderViewMobile
